import React, { useEffect, useState } from "react";
import { Box, Button } from "@mui/material";
import { useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import {useDispatch} from 'react-redux';
import LeadDialog from "../../../Components/LeadDialog";
import { StyledFlexEnd, StyledGridContainer } from "../../../Components/Styled";
import { handleValidateCodevalue } from "../../../Utility/constant";
import { createRequestData, getRequestData, updateRequestData } from "../../../Utility/apiHelper";
import { applyTheme, cacheTheme } from "../../../Utility/theme";
import { requestShowDialogLoader,requestHideDialogLoader } from "../../../Store/Global/action";
import ColorField, { isValidColor } from "./ColorField";
import LeadAccordion from "../../../Components/LeadAccordion";
import InfoIcon from "../../../Components/Widgets/InfoIcon";

const DEFAULT_PRIMARY_COLOR = "#1242C9";
const DEFAULT_SECONDARY_COLOR = "#84C8FF";
const DEFAULT_LINK_COLOR = "#1976d2";


const ClientThemeDialog = ({ open, handleClose }) => {
  const dispatch = useDispatch();
const [clientTheme, setClientTheme] = useState({
    primaryColor: DEFAULT_PRIMARY_COLOR,
    secondaryColor: DEFAULT_SECONDARY_COLOR,
    linkColor : DEFAULT_LINK_COLOR
  });
  
  useEffect(()=>{
    getThemeData();
  },[])
  const getThemeData = async()=>{
     try {
      dispatch(requestShowDialogLoader());
        const url = `/entity-customizations/THEME`;
        const response = await getRequestData(url);
        if (response?.status === 200) {
          const themeData = response?.data?.columnJson || {};
          setClientTheme((prev) => ({
            ...prev,
            primaryColor: themeData.primaryColor || prev.primaryColor,
            secondaryColor: themeData.secondaryColor || prev.secondaryColor,
            linkColor: themeData.linkColor || prev.linkColor,
            id: response?.data?.id || null,
          }));
        } 
      } catch (error) {
  }
  finally{
    dispatch(requestHideDialogLoader());
  }
}
  const internationalise = useSelector(
    (state) => state?.internationalise?.currentHashMapData
  );


  const { enqueueSnackbar } = useSnackbar();

const resetColorsToDefault = () => {
  setClientTheme((prev)=>({
    ...prev,
    primaryColor: DEFAULT_PRIMARY_COLOR,
    secondaryColor: DEFAULT_SECONDARY_COLOR,
    linkColor : DEFAULT_LINK_COLOR,
  }));
}
  const handleChangeColor = (event) => {
    const { name, value } = event.target;

    setClientTheme((previousTheme) => ({
      ...previousTheme,
      [name]: value,
    }));
  };

const handleSave = async () => {
  if (
      !isValidColor(clientTheme.primaryColor) ||
      !isValidColor(clientTheme.secondaryColor) ||
      !isValidColor(clientTheme.linkColor)
    ) {
      enqueueSnackbar(
        handleValidateCodevalue(internationalise, "INVALID_COLOR_CODE_MESSAGE"),
        { variant: "error" }
      );
      return;
    }

  const theme = {
    primaryColor: clientTheme.primaryColor.trim(),
    secondaryColor: clientTheme.secondaryColor.trim(),
    linkColor: clientTheme.linkColor.trim(),
  };

  const payload = {
      entityName: "THEME",
      columnJson : theme,
    }
  try {
    dispatch(requestShowDialogLoader());
    const url = `/entity-customizations`;
    const response = clientTheme?.id ?
    await updateRequestData(payload,`${url}/${clientTheme?.id}`) 
    : await createRequestData(payload,url);

    if (response?.status >= 200 && response?.status <= 300) {
      // apply immediately, so the CSS variables update without a reload
      applyTheme(payload?.columnJson);
      cacheTheme(payload?.columnJson);
      getThemeData();
      enqueueSnackbar(
        handleValidateCodevalue(internationalise, "THEME_UPDATED_SUCCESSFULLY"),
        { variant: "success" }
      );
    } else {
      enqueueSnackbar(
        handleValidateCodevalue(internationalise, "THEME_UPDATE_FAILED"),
        { variant: "error" }
      );
    }
  } catch (error) {
    enqueueSnackbar(
      handleValidateCodevalue(internationalise, "THEME_UPDATE_FAILED"),
      { variant: "error" }
    );
  }
  finally{
    dispatch(requestHideDialogLoader());
  }
};

  return (
    <LeadDialog
      open={open}
      handleClose={handleClose}
      size="xl"
      title={handleValidateCodevalue(internationalise, "CT_SET_CLIENT_THEME")}
      btnlabel={handleValidateCodevalue(internationalise, "COMMON_SAVE")}
      handleSave={handleSave}
    >
      
    <Box className= 'client-theme-container'>
    <InfoIcon
      text = "SET_CT_INFO"
    /> 
        <StyledFlexEnd>
            <Button className='edit-primary btn-space' variant="outlined" onClick = {resetColorsToDefault}>{handleValidateCodevalue(internationalise,"CT_RESET_TO_DEFAULT")}</Button>
        </StyledFlexEnd>
      <LeadAccordion
        label =  {handleValidateCodevalue(internationalise,'CT_BASIC_COLORS')}
        defaultOpen = {true}>
        <StyledGridContainer className = "mt-15">
          <ColorField
            name="primaryColor"
            label={handleValidateCodevalue(internationalise,"CT_PRIMARY_COLOR_HEX_CODE")}
            value={clientTheme.primaryColor}
            handleOnChange={handleChangeColor}
            fallbackColor={DEFAULT_PRIMARY_COLOR}
          />
          <ColorField
            name="secondaryColor"
            label={handleValidateCodevalue(internationalise,"CT_SECONDARY_COLOR_HEX_CODE")}
            value={clientTheme.secondaryColor}
            handleOnChange={handleChangeColor}
            fallbackColor={DEFAULT_SECONDARY_COLOR}
          />
          <ColorField
            name="linkColor"
            label={handleValidateCodevalue(internationalise,"CT_LINK_COLOR_HEX_CODE")}
            value={clientTheme.linkColor}
            handleOnChange={handleChangeColor}
            fallbackColor={DEFAULT_LINK_COLOR}
          />
        </StyledGridContainer>
        </LeadAccordion>
        </Box>
    </LeadDialog>
  );
};

export default ClientThemeDialog;